import Wrapper from '../../components/WrapperWithoutMenu';
import { ChangePasswordContent } from './changePassword';
import { RecoveryPasswordContent } from './recoveryPassword';
import { SetPasswordContent } from './setPassword';

export const RecoverPassword = () => <Wrapper Component={RecoveryPasswordContent} />;

export const ChangePassword = () => <Wrapper Component={ChangePasswordContent} />;

export const SetPassword = () => <Wrapper Component={SetPasswordContent} />;
